/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".picture-symbol-preview{display:inline-block;margin-left:5px}.picture-symbol-preview img{width:32px}.legendWideControlGroup{margin:0 0 5px}.legendWideControlGroup label{margin-top:4px;font-weight:700}.symbol-editor input.checkbox{position:relative;top:5px}.symbol-editor label{margin-bottom:8px}.color-swatch{display:inline-block;width:60%;height:30px;border:1px solid #a9a9a9}.color-swatch:hover{border:1px solid #000;cursor:pointer}.cancel-button{margin:7px 7px 0 0}.cancel-button:hover{cursor:pointer}.color-picker .sketch-picker{width:200px}"];
export { styles as styles };
